/* eslint-disable import/prefer-default-export */
import { RootState } from 'app/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectHasIntroductionToolTips = createSelector(
  [
    (state: RootState) => state.ui.introductionToolTips,
    (state: RootState) => state.ui.dashboardViewLayout,
    (state: RootState) => state.accessibleDashboards.status,
    (state: RootState) => state.accessibleDashboards.labelsEntities
  ],
  (introductionToolTips, dashboardViewLayout, dashboardInfoStatus, labelsEntities) => ({
    hasLabelTooltip:
      !introductionToolTips.labelsIsRead &&
      !dashboardViewLayout.presentationMode &&
      dashboardInfoStatus === 'succeeded' &&
      Object.keys(labelsEntities).length > 0,
    hasSidePanelTooltip:
      !introductionToolTips.sidePanelIsRead && !dashboardViewLayout.presentationMode
  })
)
